import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {sqlFormatterBlock} from "@/state/features/types";
import {formatSQL, SQLLanguages} from "@/formatters/sql";
import {DataTypeCase, KeywordCase} from "sql-formatter";


const initialState: sqlFormatterBlock = {
    text: "\n\n\n\n\n\n\n\n\n\n\n\n\n",
    sqlLanguage: <SQLLanguages> "postgresql",
    keywordCase: "upper",
    dataTypeCase: "upper"
};




export const sqlFormatterSlice = createSlice({
    name: 'sqlFormatter',
    initialState,
    reducers: {
        formatText: function (state, action: PayloadAction<string>) {
            state.text = formatSQL(state.text, state.sqlLanguage, state.keywordCase as KeywordCase, state.dataTypeCase as DataTypeCase);
        },
        updateText: function (state, action: PayloadAction<string>) {
            state.text = action.payload;
        },
        updateSQLLanguage: function (state, action: PayloadAction<SQLLanguages>) {
            state.sqlLanguage = action.payload
        },
        updateKeywordCase: function (state, action: PayloadAction<string>) {
            state.keywordCase = action.payload
        },
        updateDataTypeCase: function (state, action: PayloadAction<string>) {
            state.keywordCase = action.payload
        }

    },
    extraReducers: (builder) => {
    },
});

const sqlFormatterReducer = sqlFormatterSlice.reducer;
export const { updateText, formatText, updateSQLLanguage, updateKeywordCase, updateDataTypeCase  } = sqlFormatterSlice.actions;

export default sqlFormatterReducer;
